module.exports = __webpack_public_path__ + "img/27.e470baea.jpg";